import Vue from 'vue'
export default {
    methods: {
        // 通过code，解析文本返回值是字符串
        getGridNameByGridCode (gridCode, textSeparator = '-', rule = [4,6,9,12,14], ruleFix = true) {
            if (!gridCode) return ''
            if (!Vue.store.state.JGridCtrl) {
                console.warn(`解析失败，未注册JGridCtrl Store`)
                return gridCode
            }
            const code = String(gridCode)
            const length = String(gridCode).length
            let codeArr = []
            rule.some(l => {
                if (l > length) return true
                codeArr.push(Vue.store.state.JGridCtrl.gridMap[code.substr(0, l)] || '')
            })
            if (ruleFix) codeArr = codeArr.filter(text => text !== '')
            return codeArr.join(textSeparator)
        },
        // 递归移除查找指定gridCode的子集合
        getRecursiveByDeepSearchCode (target = [], mounted = [], code, deep, onlyChild) {
            target.some(item => {
                if (item.key == code) {
                    if (onlyChild) mounted.push(...(item.children || []))
                    else mounted.push(item)
                    return true
                }
                if (item.deep < deep && item.children && item.children.length > 0) {
                    this.getRecursiveByDeepSearchCode(item.children, mounted, code, deep, onlyChild)
                }
            })
        },
        // 递归移除指定深度的树父级节点 target: 初始树数组（注意引用类型问题）, mounted: 筛选结果挂载到该数组下， deep：需要遍历到的深度
        getRecursiveByDeepRemoveParent (target = [], mounted = [], deep = 4) {
            target.forEach(item => {
                if (item.deep === deep) {
                    mounted.push(item)
                }
                if (item.deep < deep && item.children && item.children.length > 0) {
                    this.getRecursiveByDeepRemoveParent(item.children, mounted, deep)
                }
            })
        },
        // 递归移除指定深度的子集级集合 target: 初始树数组，直接对该参数进行操作, deep：需要遍历到的深度
        getRecursiveByDeepRemoveChild (target = [], deep = 4) {
            target.forEach(item => {
                if (item.deep === deep) {
                    item.children = null
                }
                if (item.deep < deep && item.children && item.children.length > 0) {
                    this.getRecursiveByDeepRemoveChild(item.children, deep)
                }
            })
        }
    }
}
